// Where supabase-js keeps the login in localStorage.
//
// On Android the installed app and Chrome are ONE browser: they share the same
// localStorage, so they shared one login too — one refresh token used by two
// windows, and one auth lock they both queue behind. When one window sat in the
// background holding that lock (or had used up the token the other was about to
// refresh), the other window's session check hung: a feed that stayed on its
// loading placeholders until the first window was reloaded.
//
// The installed app therefore keeps its own login under its own key (and so its
// own lock and its own token). It needs one sign-in the first time. iPhones are
// left as they were: an installed app there already has storage of its own, and
// desktop browsers keep the shared key so nobody is signed out for no reason.
export function pickAuthStorageKey(baseKey, { standalone, userAgent }) {
  const onAndroid = /android/i.test(userAgent || "");
  return standalone && onAndroid ? `${baseKey}-app` : baseKey;
}
